import React, { useMemo } from "react";

// CSS-only celestial starfield (stars + drifting gold dust).
// Cheaper than tsparticles; preserves the design intent.
export default function Starfield({ density = 40, dustDensity = 14 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: density }).map((_, i) => ({
        id: `s-${i}`,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        size: 1 + Math.random() * 2.5,
        delay: `${Math.random() * 4}s`,
        duration: `${3 + Math.random() * 5}s`,
      })),
    [density],
  );
  const dust = useMemo(
    () =>
      Array.from({ length: dustDensity }).map((_, i) => ({
        id: `d-${i}`,
        left: `${Math.random() * 100}%`,
        bottom: `-${Math.random() * 20}px`,
        delay: `${Math.random() * 18}s`,
        duration: `${14 + Math.random() * 14}s`,
        scale: 0.6 + Math.random() * 1.4,
      })),
    [dustDensity],
  );

  return (
    <div className="starfield" aria-hidden>
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            top: s.top,
            left: s.left,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: s.delay,
            animationDuration: s.duration,
          }}
        />
      ))}
      {dust.map((d) => (
        <span
          key={d.id}
          className="gold-dust"
          style={{
            left: d.left,
            bottom: d.bottom,
            transform: `scale(${d.scale})`,
            animationDelay: d.delay,
            animationDuration: d.duration,
          }}
        />
      ))}
    </div>
  );
}
